import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import PolosSection from "../components/PolosSection";
import BusinessBanner from "../components/BusinessBanner";
import HoodiesSection from "../components/HoodiesSection";
import CustomApparelSection from "../components/CustomApparelSection";
import TwoWaysSection from "../components/TwoWaysSection";
import GroupOrdersSection from "../components/GroupOrdersSection";
import BestSellersSection from "../components/BestSellersSection";
import OccasionsSection from "../components/OccasionsSection";
import DesignServiceSection from "../components/DesignServiceSection";
import MoreProductsSection from "../components/MoreProductsSection";
import AboutSection from "../components/AboutSection";
import ContactSection from "../components/ContactSection";
import BulkCTA from "../components/BulkCTA";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[color:var(--dms-cream)]">
      <Navbar />
      <Hero />
      <PolosSection />
      <BusinessBanner />
      <HoodiesSection />
      <CustomApparelSection />
      <TwoWaysSection />
      <GroupOrdersSection />
      <BestSellersSection />
      <OccasionsSection />
      <DesignServiceSection />
      <MoreProductsSection />
      <AboutSection />
      <ContactSection />
      <BulkCTA />
      <Footer />
    </div>
  );
}
